<template>
    <div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" 
                             sizes="(max-width: 479px) 100vw, 84.03125px"
                             loading="lazy" 
                             class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ totalQuestions }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / totalQuestions) * 100) }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Birth Gender -->
                <!-- Childbearing Status -->
                <div class="question-container" v-if="questionId ===1">
                    <div class="question-div-2">
                        <div class="text-block-513">Please provide additional information on your childbearing potential:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleChildbearingStatus">
                               
                                    <a v-for="option in childbearingOptions" 
                                       :key="option.value"
                                       href="#" 
                                       @click.prevent="selectChildbearingStatus(option)" 
                                       class="link-block-30 w-inline-block">
                                        <div class="text-block-545">{{ option.label }}</div>
                                        <div class="text-block-546">-></div>
                                    </a>
                                
                                <textarea v-if="needsChildbearingDetails"
                                        v-model="formData.childBearingDetails"
                                        class="text-field-43 w-input"
                                        :placeholder="childBearingPlaceholder"
                                        required></textarea>
                                <input v-if="needsChildbearingDetails" 
                                       type="submit" 
                                       class="form-button w-button" 
                                       value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Hair Loss Timeline -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">When did you first notice hair loss or hair thinning?</div>
                        <div class="felix-form-block w-form">
                            <a v-for="option in timelineOptions" 
                               :key="option"
                               href="#" 
                               @click.prevent="handleTimeline(option)" 
                               class="link-block-30 w-inline-block">
                                <div class="text-block-545">{{ option }}</div>
                                <div class="text-block-546">-></div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Areas of Hair Loss -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">On what areas are you experiencing hair loss or thinning?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleHairLossArea">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="area in hairLossAreas"  :key="area">
                                        <input type="checkbox" :value="area" v-model="formData.areas" class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{area}}</span>
                                </label>
                                <textarea v-if="formData.areas.includes('Other')"
                                        v-model="formData.otherAreas"
                                        class="text-field-43 w-input"
                                        placeholder="Please specify other areas..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Physician Evaluation -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you ever had your hair loss evaluated by a physician?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handlePhysicianEval('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handlePhysicianEval('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Diagnosis -->
                <div class="question-container" v-if="questionId === 5 && formData.physicianEval === 'Yes'">
                    <div class="question-div-2">
                        <div class="text-block-513">Please select any diagnoses that you have been given:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleDiagnosisSubmit">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="diagnosis in diagnosisOptions" :key="diagnosis">
                                        <input type="checkbox" :value="diagnosis" v-model="formData.diagnoses" class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{diagnosis}}</span>
                                </label>
                                
                                <textarea v-if="formData.diagnoses.includes('Other hair loss diagnosis')"
                                        v-model="formData.otherDiagnosis"
                                        class="text-field-43 w-input"
                                        placeholder="Please specify your diagnosis..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Additional Symptoms -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any of the following symptoms in addition to your hair loss?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSymptomsSubmit">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="symptom in symptomOptions"  :key="symptom">
                                        <input type="checkbox" :value="symptom" v-model="formData.symptoms" class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{symptom}}</span>
                                </label>
                                <textarea v-if="needsSymptomsDetails"
                                        v-model="formData.symptomsDetails"
                                        class="text-field-43 w-input"
                                        placeholder="Please describe your symptoms..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Previous Treatments -->
                <div class="question-container" v-if="questionId === 7">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you tried any treatments for your hair loss?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handlePreviousTreatments('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handlePreviousTreatments('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Treatment Details -->
                <div class="question-container" v-if="questionId === 8 && !askDetailsTreatment && !askDetailsSideEffects">
                    <div class="question-div-2">
                        <div class="text-block-513">Select treatments you have tried:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleTreatmentRecieved">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="treatment in treatmentOptions"  :key="treatment">
                                    <input type="checkbox" :value="treatment" v-model="formData.treatments" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{treatment}}</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <div class="question-container" v-if="questionId === 8  && askDetailsTreatment">
                    <div class="question-div-2">
                        <div class="text-block-513">Please describe the results of the treatments you used:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="askDetailsSideEffects=true; askDetailsTreatment=false;">
                                <textarea v-model="formData.treatmentResults"
                                        class="text-field-43 w-input"
                                        placeholder="Please describe the results of the treatments you used..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <div class="question-container" v-if="questionId === 8  && askDetailsSideEffects">
                    <div class="question-div-2">
                        <div class="text-block-513">Did you experience any side effects?:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1487">
                                    <a href="#" @click.prevent="handleSideEffects('No')" class="button-68 w-button">No</a>
                                    <a href="#" @click.prevent="handleSideEffects('Yes')" class="button-68 w-button">Yes</a>
                                </div>
                                <textarea v-if="formData.hadSideEffects === 'Yes'"
                                        v-model="formData.sideEffectsDetails"
                                        class="text-field-43 w-input"
                                        placeholder="Please describe any side effects..."
                                        required></textarea>
                                <input v-if="formData.hadSideEffects === 'Yes'" type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Pregnancy Status -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently pregnant, breastfeeding, or planning to get pregnant in the next 6 months?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handlePregnancyStatus('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handlePregnancyStatus('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Medical Conditions -->
                <div class="question-container" v-if="questionId === 10">
                    <div class="question-div-2">
                        <div class="text-block-513">Please provide details of any chronic medical conditions:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleMedicalConditionsSubmit">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="condition in medicalConditions"  :key="condition">
                                    <input type="checkbox" :value="condition" v-model="formData.conditions" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{condition}}</span>
                                </label>
                                <textarea v-if="needsConditionDetails"
                                        v-model="formData.conditionDetails"
                                        class="text-field-43 w-input"
                                        placeholder="Please describe your medical conditions..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Recent Check-up -->
                <div class="question-container" v-if="questionId === 11">
                    <div class="question-div-2">
                        <div class="text-block-513">How long ago was your most recent check-up with a physician?</div>
                        <div class="felix-form-block w-form">
                            <a v-for="option in checkupOptions" 
                               :key="option"
                               href="#" 
                               @click.prevent="handleCheckup(option)" 
                               class="link-block-30 w-inline-block">
                                <div class="text-block-545">{{ option }}</div>
                                <div class="text-block-546">-></div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Allergies -->
                <div class="question-container" v-if="questionId === 12">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have any allergies or intolerances to food, dyes, medications, antibiotics, or anything else?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handleAllergies('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handleAllergies('No')" class="button-68 w-button">No</a>
                            </div>
                            <form v-if="formData.hasAllergies === 'Yes'" @submit.prevent="handleAllergiesSubmit">
                                <textarea v-model="formData.allergiesDetails"
                                        class="text-field-43 w-input"
                                        placeholder="Please list all allergies..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Medications -->
                <div class="question-container" v-if="questionId === 13">
                    <div class="question-div-2">
                        <div class="text-block-513">List all medications and supplements you are prescribed/taking. If none, please write "none."</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleMedicationsSubmit">
                                <textarea v-model="formData.medications"
                                        class="text-field-43 w-input"
                                        placeholder="List your medications and supplements..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Additional Information -->
                <div class="question-container" v-if="questionId === 14">
                    <div class="question-div-2">
                        <div class="text-block-513">Here's your first message to your doctor. Please introduce yourself and feel free to ask any questions.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleAdditionalInfoSubmit">
                                <textarea v-model="formData.additionalInfo"
                                        class="text-field-43 w-input"
                                        placeholder="Type your message here..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Photo Upload -->
                <div class="question-container" v-if="questionId === 15">
                    <div class="question-div-2">
                        <div class="text-block-513">Please provide a picture of you facing forward</div>
                        <div class="felix-form-block w-form">
                            <ImageUploader image-type="font_facing_image" :question-id="questionId" @image-uploaded="handleImageUploaded" />
                        </div>
                    </div>
                </div>

                <div class="question-container" v-if="questionId === 16">
                    <div class="question-div-2">
                        <div class="text-block-513">Please provide a picture of the top of your head</div>
                        <div class="felix-form-block w-form">
                            <ImageUploader image-type="top_head_image" :question-id="questionId" @image-uploaded="handleImageUploaded" />
                        </div>
                    </div>
                </div>

                <div class="question-container" v-if="questionId === 17">
                    <div class="question-div-2">
                        <div class="text-block-513">Please upload a photo of the front of your ID</div>
                        <div class="felix-form-block w-form">
                            <ImageUploader image-type="id_front_image" :question-id="questionId" @image-uploaded="handleImageUploaded" />
                        </div>
                    </div>
                </div>
                <div class="question-container" v-if="questionId === 18">
                    <div class="question-div-2">
                        <div class="text-block-513">Please upload a photo of the back of your ID</div>
                        <div class="felix-form-block w-form">
                            <ImageUploader image-type="id_back_image" :question-id="questionId" @image-uploaded="handleImageUploaded" />
                        </div>
                    </div>
                </div>

                <!-- Consent -->
                <div class="question-container" v-if="questionId === 19">
                    <div class="question-div-2">
                        <div class="text-block-513">Please acknowledge that you understand and agree to the following:</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleFinalSubmit">
                                <div class="consent-text">{{ consentText }}</div>
                                <label class="w-checkbox checkbox-field-15">
                                    <input type="checkbox" 
                                           v-model="formData.consent"
                                           required
                                           class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">
                                        I acknowledge and agree to the above
                                    </span>
                                </label>
                                <input type="submit" 
                                       class="form-button w-button" 
                                       value="Submit"
                                       :disabled="!formData.consent">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import ImageUploader from "../common/imageUploadBox.vue"
export default {
    name: 'FemaleHairLossQuestionnaire',
    components: {
        ImageUploader
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            totalQuestions: 19,
            askDetailsTreatment: false,
            askDetailsSideEffects:false,
            formData: {
                gender: '',
                childBearingStatus: null,
                childBearingDetails: '',
                hairLossTimeline: '',
                areas: [],
                otherAreas: '',
                physicianEval: null,
                diagnoses: [],
                otherDiagnosis: '',
                symptoms: [],
                symptomsDetails: '',
                previousTreatments: null,
                treatments: [],
                treatmentResults: '',
                hadSideEffects: null,
                sideEffectsDetails: '',
                isPregnant: null,
                conditions: [],
                conditionDetails: '',
                lastCheckup: '',
                hasAllergies: null,
                allergiesDetails: '',
                medications: '',
                additionalInfo: '',
                photos: {
                    font_facing_image: null,
                    top_head_image: null,
                    id_front_image: null,
                    id_back_image: null
                },
                consent: false
            },
            genderOptions: [
                'Genetically Female',
                'Genetically Male'
            ],
            childbearingOptions: [
                { 
                    label: 'I am post-menopausal',
                    value: 'post-menopausal',
                    requiresDetails: false
                },
                {
                    label: 'I do not have childbearing potential due to a permanent surgical procedure or other reason',
                    value: 'no-potential',
                    requiresDetails: true
                },
                {
                    label: 'I have child-bearing potential but am on birth control',
                    value: 'on-birth-control',
                    requiresDetails: true
                },
                {
                    label: 'I have childbearing potential and do not use any birth control method',
                    value: 'no-birth-control',
                    requiresDetails: false
                }
            ],
            timelineOptions: [
                'Not started yet, I\'m trying to prevent it',
                'Recently, within the last month',
                'Over the last 6 months to a year',
                'Over a year'
            ],
            hairLossAreas: [
                'No significant hair loss yet, I\'m trying to prevent',
                'Hairline (Front)',
                'Crown and Hairline',
                'Diffuse across the entire scalp',
                'Facial hair',
                'Eyebrows/eyelashes',
                'Other'
            ],
            diagnosisOptions: [
                'Androgenetic alopecia',
                'Alopecia areata',
                'Traction alopecia',
                'Telogen effluvium',
                'Discoid Lupus',
                'Scarring Alopecia',
                'Frontal Fibrosing Alopecia',
                'Other hair loss diagnosis',
                'I have not been given a diagnosis'
            ],
            symptomOptions: [
                'Itching, burning, redness, and/or scalp tenderness',
                'Bumps, sores, or rashes on your scalp',
                'Sudden high volume of hair loss/shedding',
                'Smooth round patches of hair loss',
                'Hair loss on other parts of my body like eyelashes/eyebrows',
                'Complete loss of hair over the entire scalp',
                'Hair loss started during or after a major medical or life event',
                'I regularly wear my hair in ways that can stress my hair/scalp',
                'My hair loss began before puberty',
                'None of the above'
            ],
            treatmentOptions: [
                'Topical Minoxidil (Rogaine)',
                'Oral Minoxidil',
                'Oral Spironolactone',
                'Topical Spironolactone',
                'Latanoprost',
                'Bimatoprost',
                'Ceterizine',
                'Topical Caffeine',
                'Ketoconazole Shampoo',
                'Topical Melatonin',
                'Other hair loss treatments',
                'No prior treatments tried'
            ],
            medicalConditions: [
                'No other medical conditions',
                'Heart conditions',
                'Vascular diseases',
                'Kidney disease/Renal insufficiency',
                'Liver disease',
                'Cancer',
                'Eye diseases',
                'Rheumatological/Bone/Joint diseases',
                'Skin diseases',
                'Thyroid/endocrine/adrenal disease',
                'Gastrointestinal disorder',
                'Other chronic medical conditions'
            ],
            checkupOptions: [
                'Within the past year',
                'Within 2 years',
                'Within 3-5 years',
                'Over 5 years ago'
            ],
            photoRequirements: [
                { 
                    label: 'Please provide a picture of you facing forward',
                    key: 'facingForward',
                    accept: 'image/*'
                },
                {
                    label: 'Please provide a picture of the top of your head',
                    key: 'topHead',
                    accept: 'image/*'
                },
                {
                    label: 'Please upload a photo of the front of your ID',
                    key: 'idFront',
                    accept: 'image/*'
                },
                {
                    label: 'Please upload a photo of the back of your ID',
                    key: 'idBack',
                    accept: 'image/*'
                }
            ],
            consentText: `I have filled out a medical intake form that will be used by a board-certified physician licensed in my state to make a medical treatment plan for me.

I understand all the questions that have been asked of me.

The information that I have provided is accurate and complete.

I am the patient who is consenting to be evaluated for treatment via telehealth.`
        }
    },
    computed: {
        needsChildbearingDetails() {
            return this.formData.childBearingStatus && this.formData.childBearingStatus.requiresDetails
        },
        childBearingPlaceholder() {
            return 'Please provide details.'
        },
        needsSymptomsDetails() {
            return this.formData.symptoms.length > 0 && !this.formData.symptoms.includes('None of the above')
        },
        needsConditionDetails() {
            return this.formData.conditions.length > 0 && !this.formData.conditions.includes('No other medical conditions')
        }
    },
    methods: {
        handleTreatmentRecieved(){
            if(this.formData.treatments.length  < 1){
                return;
            }else{
                this.askDetailsTreatment=true;
            }
        },
        handleSymptomsSubmit(){
            if(this.formData.symptoms.length  < 1){
                return;
            }else{
                this.nextQuestion();
            }
        },
        handleDiagnosisSubmit(){
            if(this.formData.diagnoses.length  < 1){
                return;
            }else{
                this.nextQuestion();
            }
        },
        handleHairLossArea(){
            if(this.formData.areas.length  < 1){
                return;
            }else{
                this.nextQuestion();
            }
        },
        handleImageUploaded(data) {
            this.formData.photos[data.type] = data.base64;
            this.nextQuestion();
        },
        handleAdditionalInfoSubmit(){
            if (this.formData.additionalInfo && this.formData.additionalInfo.trim()) {
                this.nextQuestion();
            }
        },
        handleMedicationsSubmit(){
            if (this.formData.medications && this.formData.medications.trim()) {
                this.nextQuestion();
            }
        },
        handleAllergies(answer){
            this.formData.hasAllergies = answer;
            if(answer==='No'){
                this.nextQuestion();
            }
        },
        handleAllergiesSubmit(){
            if (this.formData.allergiesDetails && this.formData.allergiesDetails.trim()) {
                this.nextQuestion();
            }
        },
        handleCheckup(answer){
            this.formData.lastCheckup = answer;
            this.nextQuestion();
        },
        handleMedicalConditionsSubmit(){
            if(this.formData.conditions.length  < 1){
                return;
            }
            if (this.formData.conditions.length > 1 &&
                this.formData.conditions.includes('No other medical conditions')) {
                this.formData.conditions = this.formData.conditions.filter(risk =>
                    risk !== 'No other medical conditions'
                );
            }

            if (this.formData.conditions.length === 1 && this.formData.conditions[0] === 'No other medical conditions') {
                this.nextQuestion();
                return;
            }
            if (this.formData.conditionDetails && this.formData.conditionDetails.trim()) {
                this.nextQuestion();
            }
        },
        handleGenderSelection(gender) {
            this.formData.gender = gender
            if (gender === 'Genetically Male') {
                this.handleDisqualification()
            } else {
                this.nextQuestion()
            }
        },
        selectChildbearingStatus(status) {
            this.formData.childBearingStatus = status
            if (!status.requiresDetails) {
                this.nextQuestion()
            }
        },
        handleChildbearingStatus() {
            if (this.formData.childBearingStatus.value === 'no-birth-control') {
                this.handleDisqualification()
            } else {
                this.nextQuestion()
            }
        },
        handleTimeline(timeline) {
            this.formData.hairLossTimeline = timeline
            this.nextQuestion()
        },
        handlePhysicianEval(answer) {
            this.formData.physicianEval = answer
            if (answer === 'No') {
                this.questionId += 2 // Skip diagnosis question
            } else {
                this.nextQuestion()
            }
        },
        handleSideEffects(answer){
            this.formData.hadSideEffects = answer;
            if(answer==='No'){
                this.askDetailsSideEffects = false;
                this.askDetailsTreatment= false;
                this.nextQuestion();
            }
        },
        handlePreviousTreatments(answer) {
            this.formData.previousTreatments = answer
            if (answer === 'No') {
                this.questionId += 2 // Skip treatment details
            } else {
                this.nextQuestion()
            }
        },
        handlePregnancyStatus(answer) {
            this.formData.isPregnant = answer
            if (answer === 'Yes') {
                this.handleDisqualification()
            } else {
                this.nextQuestion()
            }
        },
        handleFileUpload(event, key) {
            const file = event.target.files[0]
            if (file) {
                this.formData.photos[key] = file
            }
        },
        handleDisqualification() {
            this.$router.push('/sorry')
        },
        nextQuestion() {
            if (this.questionId < this.totalQuestions) {
                this.questionId++
            }
            window.scrollTo(0, 0)
        },
        async handleFinalSubmit() {
            if (!this.formData.consent) {
                return
            }

            try {
                const formData = new FormData()
                
                // Format the form data
                const formattedData = {
                    formObj: {
                        consentsSigned: true,
                        // Format Q&A pairs with full questions and available options
                        Q1: `Please provide additional information on your childbearing potential. Available Options: ${this.childbearingOptions.map(opt => opt.label).join(', ')}`,
                        A1: `${this.formData.childBearingStatus?.label}${this.formData.childBearingDetails ? ': ' + this.formData.childBearingDetails : ''}`,

                        Q2: `When did you first notice hair loss or hair thinning? Available Options: ${this.timelineOptions.join(', ')}`,
                        A2: this.formData.hairLossTimeline,

                        Q3: `On what areas are you experiencing hair loss or thinning? Available Options: ${this.hairLossAreas.join(', ')}`,
                        A3: `${this.formData.areas.join('; ')}${this.formData.otherAreas ? '; Other: ' + this.formData.otherAreas : ''}`,

                        Q4: "Have you ever had your hair loss evaluated by a physician? Available Options: Yes, No",
                        A4: this.formData.physicianEval,

                        Q5: `Please select any diagnoses that you have been given. Available Options: ${this.diagnosisOptions.join(', ')}`,
                        A5: `${this.formData.diagnoses.join('; ')}${this.formData.otherDiagnosis ? '; Other: ' + this.formData.otherDiagnosis : ''}`,

                        Q6: `Do you have any of the following symptoms in addition to your hair loss? Available Options: ${this.symptomOptions.join(', ')}`,
                        A6: `${this.formData.symptoms.join('; ')}${this.formData.symptomsDetails ? '\nDetails: ' + this.formData.symptomsDetails : ''}`,

                        Q7: "Have you tried any treatments for your hair loss? Available Options: Yes, No",
                        A7: this.formData.previousTreatments,

                        Q8: `Select treatments you have tried. Available Options: ${this.treatmentOptions.join(', ')}`,
                        A8: `Treatments: ${this.formData.treatments.join('; ')}\nResults: ${this.formData.treatmentResults || 'None'}\nSide Effects: ${this.formData.hadSideEffects === 'Yes' ? this.formData.sideEffectsDetails : 'None'}`,

                        Q9: "Are you currently pregnant, breastfeeding, or planning to get pregnant in the next 6 months? Available Options: Yes, No",
                        A9: this.formData.isPregnant,

                        Q10: `Please provide details of any chronic medical conditions. Available Options: ${this.medicalConditions.join(', ')}`,
                        A10: `${this.formData.conditions.join('; ')}${this.formData.conditionDetails ? '\nDetails: ' + this.formData.conditionDetails : ''}`,

                        Q11: `How long ago was your most recent check-up with a physician? Available Options: ${this.checkupOptions.join(', ')}`,
                        A11: this.formData.lastCheckup,

                        Q12: "Do you have any allergies or intolerances to food, dyes, medications, antibiotics, or anything else? Available Options: Yes, No",
                        A12: `${this.formData.hasAllergies}${this.formData.allergiesDetails ? ': ' + this.formData.allergiesDetails : ''}`,

                        Q13: "List all medications and supplements you are prescribed/taking. If none, please write 'none.'",
                        A13: this.formData.medications || "None",

                        Q14: "Here's your first message to your doctor. Please introduce yourself and feel free to ask any questions.",
                        A14: this.formData.additionalInfo || "None",

                        Q15: "Please provide a picture of you facing forward",
                        A15: this.formData.photos.font_facing_image ? "Photo uploaded" : "No photo uploaded",

                        Q16: "Please provide a picture of the top of your head",
                        A16: this.formData.photos.top_head_image ? "Photo uploaded" : "No photo uploaded",

                        Q17: "Please upload a photo of the front of your ID",
                        A17: this.formData.photos.id_front_image ? "Photo uploaded" : "No photo uploaded",

                        Q18: "Please upload a photo of the back of your ID",
                        A18: this.formData.photos.id_back_image ? "Photo uploaded" : "No photo uploaded",

                        Q19: "Consent Acknowledgment",
                        A19: this.formData.consent ? "Consented" : "Not consented"
                    },
                    pharmacyId: "",
                    masterId: `visit_${Date.now()}`,
                    company: "newSelf",
                    visitType: "hairloss"
                }

                // Add formatted data to FormData
                formData.append('formData', JSON.stringify(formattedData))

                // Add photos separately
                Object.entries(this.formData.photos).forEach(([key, value]) => {
                    if (value) {
                        formData.append(`photos[${key}]`, value)
                    }
                })

                const response = await this.$axios.post(`${this.baseUrl}/forms/assessment-form/hairloss/${this.$route.params.id}`, formData)

                if (response.data.status === 'success') {
                    this.$router.push('/success');
                } else {
                    throw new Error('Form submission failed')
                }
            } catch (error) {
                console.error('Error submitting form:', error)
                alert('There was an error submitting your form. Please try again.')
            }
        }
    }
}
</script>

<style scoped>
textarea.w-input, textarea.w-select {
    height: auto;
    width: 100%;
}

</style>